import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllDestinationsResponseModel, DestinationResponseModel } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { DestinationAdapter } from './dto/destination.adapter';
import { DestinationDTO } from './dto/destination.dto';
import {DestinationRequest} from './dto/destination.request'
import { Destination } from './destination.entity';
import { CountryForDestinationRequest } from './dto/destination-for-country-request';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { UserRequestDto } from './dto/user-request-dto';

@Injectable()
export class DestinationService {
    constructor(
      private logService:LogsService,

        @InjectRepository(Destination)
        private destinationRepository: Repository<Destination>,
        private destinationAdapter: DestinationAdapter,
      ){}
      async getDestinationWithoutRelations(destinationName:string):
         Promise<Destination>{
          //  console.log(destinationId);
        const DestinationResponse = await this.destinationRepository.findOne({
          where: {destinationId: Raw(alias => `destination_name = '${destinationName}'`)},
        });
        if(DestinationResponse){
          return DestinationResponse;
        }
        else{
          return null;
        }
      }
  
      async createDestination(destinationDTO: DestinationDTO, isUpdate: boolean): Promise<DestinationResponseModel>{
  
        // const response = new DestinationResponseModel();
        try{
          let previousValue
          // const newLogDto = new LogsDto(1,'updated', 'Destination', destinationDTO.destinationId, true, '',destinationDTO.createdUser)
          //   let res = await this.logService.createLog(newLogDto);
          //   console.log(res);
        // const destinationDtos: DestinationDTO = '';
        console.log(destinationDTO);
          if(!isUpdate){
            const DestinationEntity = await this.getDestinationWithoutRelations(destinationDTO.destinationName);
            
            if (DestinationEntity){
              throw new DestinationResponseModel(false,11104, 'Destination already exists'); 
            }
          }
          else{
            const certificatePrevious = await this.destinationRepository.findOne({where:{destinationId:destinationDTO.destinationId}})
            previousValue =(certificatePrevious.destinationName)
            const DestinationEntity = await this.getDestinationWithoutRelations(destinationDTO.destinationName);
            
            if (DestinationEntity){
              if (DestinationEntity.destinationId!= destinationDTO.destinationId) {
              throw new DestinationResponseModel(false,11104, 'Destination already exists'); 
              }
            }
          }
          const convertedDestinationEntity: Destination = this.destinationAdapter.convertDtoToEntity(destinationDTO,isUpdate);

          // console.log(convertedDestinationEntity);
        const savedDestinationEntity: Destination = await this.destinationRepository.save(convertedDestinationEntity);
        // console.log(convertedDestinationEntity);
        const savedDestinationDto: DestinationDTO = this.destinationAdapter.convertEntityToDto(savedDestinationEntity);
        // destinationDtos.push(savedDestinationDto)
          console.log(savedDestinationDto);
        if (savedDestinationDto) {
          const presentValue = savedDestinationDto.destinationName;

          //generating resposnse
          const response = new DestinationResponseModel(true,1,isUpdate? 'Destination Updated Successfully': 'Destination Created Successfully',savedDestinationDto);
          const name=isUpdate?'updated':'created'
          const displayValue = isUpdate? 'Destination Updated Successfully': 'Destination Created Successfully'
          const userName = isUpdate? savedDestinationDto.updatedUser :savedDestinationDto.createdUser;
          const newLogDto = new LogsDto(1,name, 'Destination',savedDestinationDto.destinationId , true, displayValue,userName,previousValue,presentValue)
          let res = await this.logService.createLog(newLogDto);
          console.log(res,'12');
         

          return response;
        } else {
          // const newLogDto = new LogsDto(1,'created', 'Destination',savedDestinationDto.destinationId , false, '',savedDestinationDto.createdUser)
          // let res = await this.logService.createLog(newLogDto);
          // console.log(res);
          //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
          throw new DestinationResponseModel(false,11106,'Destination saved but issue while transforming into DTO');
        }
        // return response;
      } catch (error) {
        // when error occures while saving the data , the execution will come to catch block.
        // tslint:disable-next-line: typedef
        return error;
      }
    }

    async getDuplicateDestination(destinationName:string,countryId:number): Promise<Destination> {
        // console.log(countryId,destinationName);
          const employeeResponse = await this.destinationRepository.findOne({
          where: {countryId: Raw(alias => `country_id = '${countryId}'`),destinationName: Raw(alias => `destination_name = '${destinationName}'`) },
          });
        
          // console.log(employeeResponse);
          if (employeeResponse) {
          return employeeResponse;
          } else {
          return null;
          }
      }

    async getAllDestinations(req?:UserRequestDto): Promise<AllDestinationsResponseModel> {
      // const page: number = 1;
      // const response = new AllDestinationsResponseModel();
      try {
        const destinationDTO: DestinationDTO[] = [];
        //retrieves all companies
        const DestinationEntity: Destination[] = await this.destinationRepository.find({ 
          relations:['CountriesInfo'],
          order :{'destinationName':'ASC'}});
        //console.log(statesEntities);
        if (DestinationEntity) {
          // converts the data fetched from the database which of type companies array to type StateDto array.
          DestinationEntity.forEach(DestinationEntity => {
            const convertedDestinationDto: DestinationDTO = this.destinationAdapter.convertEntityToDto(
            DestinationEntity
            );
            destinationDTO.push(convertedDestinationDto);
          });
          //generated response
          const response = new AllDestinationsResponseModel(true,1,'Destination retrieved successfully',destinationDTO);
         if(req?.createdUser){
          const newLogDto = new LogsDto(1,'view', 'Destination', 0, true, 'Destination retrieved successfully',req.createdUser,"","")
          let res = await this.logService.createLog(newLogDto);
          console.log(res);
         
         }
          
          return response;
        } else {
          
          throw new DestinationResponseModel(false,99998, 'Data not found');
        }
        // return response;
      } catch (err) {
        return err;
      }
    }  
    async getAllActiveDestinations(): Promise<AllDestinationsResponseModel> {
      // const page: number = 1;
      try {
          const destinationDTO: DestinationDTO[] = [];
          //retrieves all companies
          const DestinationEntity: Destination[] = await this.destinationRepository.find({ order: { 'destinationName': 'ASC' },where:{isActive:true},
         });
      //  console.log(DestinationEntity)
          if (DestinationEntity) {
              // converts the data fetched from the database which of type companies array to type StateDto array.
              DestinationEntity.forEach(DestinationEntity => {
                  const convertedDestinationDto: DestinationDTO = this.destinationAdapter.convertEntityToDto(
                    DestinationEntity
                    
                  );
                  destinationDTO.push(convertedDestinationDto);
              });
              const response = new AllDestinationsResponseModel(true, 11108, "Destinations retrieved successfully", destinationDTO);
              return response;
          } else {
              throw new DestinationResponseModel(false,99998, 'Data not found'); destinationDTO
          }
      } catch (err) {
        return err;
      }
  }
  
  async getDestinationsByCountry(countryReq: CountryForDestinationRequest): Promise<AllDestinationsResponseModel> {
    // const page: number = 1;
    try {
        const destinationDTO: DestinationDTO[] = [];
        //retrieves all companies
        const DestinationEntity: Destination[] = await this.destinationRepository.find({ order: { destinationName: 'ASC' },where:{countryId:countryReq.countryId,isActive:true},
       });
    //  console.log(DestinationEntity)
        if (DestinationEntity) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            DestinationEntity.forEach(DestinationEntity => {
                const convertedDestinationDto: DestinationDTO = this.destinationAdapter.convertEntityToDto(
                  DestinationEntity
                  
                );
                destinationDTO.push(convertedDestinationDto);
            });
            const response = new AllDestinationsResponseModel(true, 11108, "Destinations retrieved successfully", destinationDTO);
            return response;
        } else {
            throw new DestinationResponseModel(false,99998, 'Data not found'); destinationDTO
        }
    } catch (err) {
      return err;
    }
}
    async activateOrDeactivateCountry(destinationReq: DestinationRequest): Promise<DestinationResponseModel> {
      try {
          const destinationExists = await this.getDestinationById(destinationReq.destinationId);
          if (destinationExists) {
              if (destinationReq.versionFlag !== destinationExists.versionFlag) {
                  throw new DestinationResponseModel(false,10113, 'Someone updated the information.Refresh and try again'); 
              } else {
                  
                      const destinationStatus =  await this.destinationRepository.update(
                          { destinationId: destinationReq.destinationId },
                          { isActive: destinationReq.isActive,updatedUser: destinationReq.updatedUser });
                     
                      if (destinationExists.isActive) {
                          if (destinationStatus.affected) {
                              const destinationResponse: DestinationResponseModel = new DestinationResponseModel(true, 10115, 'de-activated successfully');
                              return destinationResponse;
                          } else {
                              throw new DestinationResponseModel(false,10111, 'already deactivated');
                          }
                      } else {
                          if (destinationStatus.affected) {
                              const destinationResponse: DestinationResponseModel = new DestinationResponseModel(true, 10114, 'activated successfully');
                              return destinationResponse;
                          } else {
                              throw new DestinationResponseModel(false,10112, 'already  activated');
                          }
                      }
                  // }
              }
          } else {
              throw new DestinationResponseModel(false,99998, 'No Records Found');
          }
      } catch (err) {
        return err;
      }
  }


  async getDestinationById(destinationId: number): Promise<Destination> {
    //  console.log(employeeId);
        const Response = await this.destinationRepository.findOne({
        where: { destinationId: destinationId},
        });
        // console.log(employeeResponse);
        if (Response) {
        return Response;
        } else {
        return null;
        }
    }


    async getDestinationsById(destinationRequest:DestinationRequest): Promise<DestinationResponseModel> {
      try {
        //retrieves all companies
        const destinationEntities: Destination = await this.destinationRepository.findOne({
            where:{destinationId:destinationRequest.destinationId}
            });
            
            const destinationData: DestinationDTO = this.destinationAdapter.convertEntityToDto(destinationEntities);
            if (destinationData) {
                const response = new DestinationResponseModel(true, 11101 , 'Destination retrived Successfully',destinationData);
                return response;
            }
            else{
                throw new DestinationResponseModel(false,11106,'Something went wrong');
            }
            // generating resposnse
    } catch (err) {
      return err;
    }
    }

}

